import React from 'react';
import { Box, Grid, Typography, TextField } from '@mui/material';
import { useDropzone } from 'react-dropzone';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

const SuggestInternalArchivingSection = ({
  suggestArchiving,
  archivingJustification,
  archivingFile,
  onSuggestArchivingChange,
  onArchivingJustificationChange,
  onArchivingFileChange,
}) => {
  const getBase64 = file => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      onArchivingFileChange({ name: file.name, base64: reader.result });
    };
  };

  const { getRootProps, getInputProps } = useDropzone({
    multiple: false,
    onDrop: acceptedFiles => {
      if (acceptedFiles.length > 0) {
        getBase64(acceptedFiles[0]);
      }
    },
  });

  return (
    <>
      <Grid style={{ marginTop: 14 }} size={12}>
        <Box display="flex" alignItems="center">
          <input
            type="checkbox"
            checked={suggestArchiving}
            onChange={e => onSuggestArchivingChange(e.target.checked)}
          />
          <Typography style={{ marginLeft: '8px' }}>Sugerir arquivamento interno?</Typography>
        </Box>
      </Grid>
      {suggestArchiving && (
        <>
          <Grid size={12}>
            <TextField
              multiline
              variant="outlined"
              fullWidth
              minRows={6}
              maxRows={10}
              label="Justificativa da sugestão de arquivamento interno*"
              value={archivingJustification}
              onChange={e => onArchivingJustificationChange(e.target.value)}
              size="small"
            />
          </Grid>
          <Grid size={12}>
            {!archivingFile ? (
              <Box
                {...getRootProps()}
                style={{
                  border: '1px dashed #292929',
                  borderRadius: 4,
                  padding: '16px',
                  textAlign: 'center',
                  cursor: 'pointer',
                }}
              >
                <input {...getInputProps()} />
                <Typography>Arraste um arquivo, ou clique para adicionar*</Typography>
              </Box>
            ) : (
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                p={1}
                style={{ border: '1px solid #ccc', borderRadius: 4 }}
              >
                <Box display="flex" alignItems="center">
                  <AttachFileIcon fontSize="small" />
                  <Typography variant="body2" style={{ marginLeft: 4 }}>
                    {archivingFile.name}
                  </Typography>
                </Box>
                <HighlightOffIcon
                  style={{ cursor: 'pointer' }}
                  onClick={() => onArchivingFileChange(null)}
                />
              </Box>
            )}
          </Grid>
          <Grid size={12}></Grid>
        </>
      )}
    </>
  );
};

export default SuggestInternalArchivingSection;
